import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { faExclamationCircle, faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./index.css";
import { animate } from "motion/react";
import { CentralAjudaService } from "../../../services/CentralAjudaService";
import { ChatAtendenteContext } from "../../../contexts/ChatAtendenteContext";
import { Alert, FormControl, Spinner } from "react-bootstrap";
import { ConteudoAtendimentoType } from "../../../types/ConteudoAtendimentoType";
import formatDommus from "../../../helpers/format";
import InfiniteScroll from "react-infinite-scroll-component";

const loadingMensangesComponente= (
  <div className="loading-mensagens">
    <Spinner
      as="span"
      animation="border"
      size="sm"
      role="status"
      aria-hidden="true"
      className="mt-1"
    /> 
    Carregando
  </div>
)

const loadingEnvioComponente = (
  <div className="mensagem-item recebido loading-envio-mensagem">
    <span className="mensagem">
      Enviando
    </span>
    <div className="dot-loader">
      <div className="dot"></div>
      <div className="dot"></div>
      <div className="dot"></div>
    </div>
  </div>
)

const fimMensagensComponente = (
  <div className="fim-mensagens-section">
    <div className="line"></div>
    <span>Fim das Mensagens</span>
    <div className="line"></div>
  </div>
)

export function ChatConversa(){
  const {atendimentoAtivo} = useContext(ChatAtendenteContext)
  const [loading, setLoading] = useState(false);
  const [loadingEnvio, setLoadingEnvio] = useState(false);
  const [mensagensAtendimento, setMensagensAtendimento] = useState<ConteudoAtendimentoType[]>([] as ConteudoAtendimentoType[]);
  const [showError, setShowError] = useState<any>(null);
  const [mensagem, setMensagem] = useState("");
  const inputTextAreaRef = useRef<HTMLTextAreaElement>(null);
  const mensagensSectionRef = useRef<HTMLDivElement>(null);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [hasMore, setHasMore] = useState(false);

  const atualizarQuantidadeLinhasTextarea = () => {
      const textarea = inputTextAreaRef?.current;
      if(textarea){
        textarea.rows = 1;
        const quantidadeLinhasTextearea = Math.ceil(
            textarea.scrollHeight /
                parseFloat(getComputedStyle(textarea).lineHeight)
        );
        textarea.rows = quantidadeLinhasTextearea <= 0 ? 1 : quantidadeLinhasTextearea >= 20 ? 20 : quantidadeLinhasTextearea - 1;
      }
  };

  const irFinalPagina = ()=>{
    const secao = mensagensSectionRef?.current;
    if(secao){
      secao.scrollTo({
          top: secao.scrollHeight,
          behavior: 'smooth'
      })
    }
  }

  const buscarMensagens = ()=>{
    const filtros = {
      page: page,
      limit: 10,
      buscar_total: (page === 1 && !mensagensAtendimento.length ? 1 : 0)
    }
    setLoading(true)
    CentralAjudaService.atendimento.buscarMensagens(atendimentoAtivo.id, filtros).then((response)=>{
      let mensagensTemp = [...mensagensAtendimento, ...response?.data?.mensagens];
      setMensagensAtendimento(mensagensTemp);
      const totalTemp = response?.data?.total ? response?.data?.total : total;
      if(totalTemp){
        setTotal(totalTemp)
      }
      setHasMore(mensagensTemp?.length < totalTemp);
      setLoading(false)
    }).catch((error) => {
      debugger
      setLoading(false)
    })
  }

  useEffect(()=>{
    buscarMensagens()
  },[atendimentoAtivo, page])
  
  const handleLoadMoreMessages = ()=>{
    setPage((current) => current + 1);
  }

  const handleOnSubmit = ()=>{
    if(!mensagem || mensagem === ""){
      animate(
          "#input-message",
          { x: [0, -5, 5, -5, 5, 0] },
          { duration: 0.4 })
      animate(
          "#input-message",
          { borderColor: ["#ccc", "red", "#ccc"] },
          { duration: 0.8 }
        );
      return;
    }

    if(page === 1){
      setLoadingEnvio(true);
    }

    setMensagem("");
    atualizarQuantidadeLinhasTextarea();
    setTimeout(()=>{
      irFinalPagina();
      const payload = {
        message: mensagem
      }
      CentralAjudaService.atendimento.enviarMensagem(atendimentoAtivo.id, payload).then((response)=>{
          setMensagensAtendimento((current) => [response.data, ...current]);
          setTotal((current) => current + 1);
          atualizarQuantidadeLinhasTextarea();
          setLoadingEnvio(false);
      }).catch((error)=>{
          setShowError(<span><FontAwesomeIcon icon={faExclamationCircle}/> Erro ao enviar mensagem. Tente novamente!</span>)
          setLoadingEnvio(false);
      })
    }, 300)
  }

  const listaMensagensCarregadas = useMemo(()=>{
    return (
      mensagensAtendimento.map((item,index)=>{
        return(
          <div key={index} className={`mensagem-item ${item.direcao}`}>
            <span className="mensagem">
              {item.direcao === 'enviado' && item?.atendente && (
                <b> {item?.atendente + " : "}</b>
              )}
              {item.conteudo ?? "---"}
            </span>
            <span className="data">
              {formatDommus.formatarDataHoraBR(item.criado_em)}
            </span>
          </div>
        )
      })
    )
  },[mensagensAtendimento])

  return(
    <div className="conversa-section">
        <div className="mensagens-section" ref={mensagensSectionRef} id="scrollableDiv">
          {(loading && page === 1) ? 
              loadingMensangesComponente
            :
                (mensagensAtendimento.length ? 
                  <>
                      {showError && <Alert variant="danger" className="show-error">{showError}</Alert>}
                      <InfiniteScroll
                          className="mensagens-section"
                          style={{ display: 'flex', flexDirection: 'column-reverse' }}
                          dataLength={mensagensAtendimento.length}
                          next={handleLoadMoreMessages}
                          hasMore={hasMore}
                          inverse={true}
                          loader={loadingMensangesComponente}
                          endMessage={fimMensagensComponente}
                          refreshFunction={() => { }}
                          pullDownToRefresh
                          pullDownToRefreshThreshold={50}
                          scrollableTarget="scrollableDiv"

                      >
                        {loadingEnvio && loadingEnvioComponente}
                        {listaMensagensCarregadas}
                      </InfiniteScroll>
                  </>
                : 
                  <></>)
          }
        </div>
      <div className="input-section">
        <div className="dommus-box-send-message-chat">

          <FormControl
              id="input-message"
              className="input-message-field"
              aria-label="Mensagens"
              ref={inputTextAreaRef}
              placeholder="Digite sua mensagem" 
              value={mensagem}
              as="textarea"
              autoFocus={true}
              rows={1}
              disabled={loadingEnvio || loading}
              onKeyDown={(e)=>{
                if(e.keyCode === 13){
                  e.preventDefault();
                  handleOnSubmit();
                  return
                }
              }}
              onChange={(e) => {
                setMensagem(e.target.value);
                atualizarQuantidadeLinhasTextarea();
              }}          
         />
         <button type="button" onClick={() => handleOnSubmit} disabled={loadingEnvio || loading}>
           <FontAwesomeIcon icon={faPaperPlane} color="#FFF" />
          </button>
        </div>
      </div>
    </div>
  )
}
